import type { QuestionnaireState } from "../../types";
import type { RuleSet } from "../../../../components/Questionnaire/validation/form/types";

export const handleSetValidationsAction = (
  state: QuestionnaireState,
  payload: readonly RuleSet[],
): QuestionnaireState => {
  return {
    ...state,
    validations: payload,
  };
};
